export default __webpack_public_path__ + "static/media/catie.7f92c952.JPG";